module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-regular.d5de5181.ttf";